import {
  EDIT_KEG_COLLECTION_BOOKING_REQUEST,
  EDIT_KEG_COLLECTION_BOOKING_SUCCESS,
  EDIT_KEG_COLLECTION_BOOKING_FAILURE,
  EDIT_KEG_COLLECTION_BOOKING_CLEAR,
  EDIT_KEG_COLLECTION_BOOKING_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  EDIT_KEG_COLLECTION_BOOKING_REQUEST,
  EDIT_KEG_COLLECTION_BOOKING_SUCCESS,
  EDIT_KEG_COLLECTION_BOOKING_FAILURE,
  EDIT_KEG_COLLECTION_BOOKING_CLEAR,
  EDIT_KEG_COLLECTION_BOOKING_QUEUE
)
